import { Alert, Box, Button, Icon, Modal, Spinner } from '@zillow/constellation-10';
import { IconLocationFilled } from '@zillow/constellation-icons';
import { useState } from 'react';
import { useAsyncFn } from 'react-use';
import { CustomerAnalyticsMoodysWebApiHandler_getMoodysGeometry } from '@zg-rentals/ts-customer-analytics-client';
import { renderPreviewMarketMap } from '../../../utils/MarketMap';
import { httpClient } from '../../../httpClient';
import { useRentalManagerUser } from '@zg-rentals/rental-manager-env';
import { emitIndustryReportsMapViewEvent } from '../../../analytics/events';

interface MapPreviewModalProps {
  areaName: string;
  metroId: string;
  submarketId?: number;
}

export const MapPreviewModal = ({ areaName, metroId, submarketId }: MapPreviewModalProps) => {
  const { user } = useRentalManagerUser();
  const [isOpen, setIsOpen] = useState(false);

  const [mapShapeState, getMoodysShape] = useAsyncFn(async () =>
    CustomerAnalyticsMoodysWebApiHandler_getMoodysGeometry(
      {
        metroId,
        submarketId,
      },
      httpClient,
    ),
  );

  const handleOnClick = () => {
    if (user) emitIndustryReportsMapViewEvent({ user });
    setIsOpen(true);
    getMoodysShape();
  };

  const renderModalContent = () => {
    if (mapShapeState.loading) {
      return (
        <Box css={{ display: 'flex', justifyContent: 'center', padding: '800' }}>
          <Spinner size="lg" />
        </Box>
      );
    }

    if (mapShapeState.error || !mapShapeState.value || mapShapeState.value.length === 0) {
      return <Alert tone="critical">There was an error retrieving this preview. Please try again later.</Alert>;
    }

    return <Box>{renderPreviewMarketMap(mapShapeState.value[0])}</Box>;
  };

  return (
    <>
      <button
        style={{
          color: '#006aff',
          cursor: 'pointer',
          textDecoration: 'underline',
          background: 'none',
          border: 'none',
          padding: '0',
          font: 'inherit',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        }}
        onClick={handleOnClick}
      >
        <Icon css={{ color: 'text.link' }}>
          <IconLocationFilled />
        </Icon>
        View on map
      </button>

      <Modal
        open={isOpen}
        onOpenChange={(isModalOpen) => {
          if (!isModalOpen) setIsOpen(false);
        }}
        size="lg"
        header={areaName || 'Report Area'}
        body={renderModalContent()}
        footer={
          <Button tone="brand" emphasis="filled" onClick={() => setIsOpen(false)} css={{ width: '100%' }}>
            Close
          </Button>
        }
      />
    </>
  );
};
